// 3rd section of the platform

// import React, { useState } from 'react';

// const InfoCarouselSection = ({ 
//   backgroundColor = 'var(--primary-color)',
//   title,
//   description,
//   cards = []
// }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handlePrev = () => {
//     setCurrentIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
//   };

//   const getCardStyle = (index) => {
//     if (index === currentIndex) {
//       // First card - full size
//       return {
//         transform: 'translateX(0) scale(1)',
//         opacity: 1,
//         zIndex: 20,
//         width: '100%'
//       };
//     } else if (index === (currentIndex + 1) % cards.length) {
//       // Second card - smaller and positioned to the right
//       return {
//         transform: 'translateX(70%) scale(0.75)',
//         opacity: 0.8,
//         zIndex: 10,
//         width: '100%'
//       };
//     } else {
//       // Hidden cards
//       return {
//         transform: 'translateX(150%) scale(0.7)',
//         opacity: 0,
//         zIndex: 0,
//         width: '100%'
//       };
//     }
//   };

//   return (
//     <div 
//       className="w-full py-10 px-4 md:px-8 lg:px-16"
//       style={{ backgroundColor }}
//     >
//       <div className="max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
//           {/* Left Section - Content */}
//           <div className="text-white space-y-4 md:space-y-6">
//             <h2 className="font-bold leading-tight">
//               {title}
//             </h2>
//             <p className="text-gray-200   leading-relaxed">
//               {description}
//             </p>
//           </div>

//           {/* Right Section - Carousel Cards */}
//           <div className="relative flex items-center justify-center lg:justify-start min-h-[350px] md:min-h-[380px]">
//             {/* Cards Container */}
//             <div className="relative w-full max-w-[240px] sm:max-w-[260px] md:max-w-[280px]" style={{ height: '320px' }}>
//               {cards.map((card, index) => (
//                 <div
//                   key={index}
//                   className="absolute top-0 left-0 transition-all duration-500 ease-in-out"
//                   style={getCardStyle(index)}
//                 >
//                   <div className="bg-white rounded-2xl shadow-2xl overflow-hidden h-full">
//                     {/* Card Image */}
//                     <div className="relative h-36 sm:h-40 md:h-44 overflow-hidden">
//                       <img
//                         src={card.image}
//                         alt={card.heading}
//                         className="w-full h-full object-cover"
//                       />
//                     </div>

//                     {/* Card Content */}
//                     <div className="p-4 sm:p-5 text-center jusitify center">
//                       <h3 className=" sm: font-bold  mb-2">
//                         {card.heading}
//                       </h3>
//                       <p className=" text-xs leading-relaxed">
//                         {card.subheading}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* Navigation Arrow - Positioned after the second card */}
//             <div 
//               className="absolute top-1/2 transform -translate-y-1/2 z-30 lg:left-auto"
//               style={{ 
//                 left: 'calc(50% + 160px)',
//               }}
//             >
//               <button
//                 onClick={handleNext}
//                 className="shadow-2xl transition-all duration-300 hover:scale-110 bg-transparent"
//                 aria-label="Next"
//               >
//                 <img 
//                   src='/assets/images/rightarrow.svg'
//                   alt="Next" 
//                   className="w-6 h-6 sm:w-7 sm:h-7 md:w-9 md:h-9"
//                 />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InfoCarouselSection;

import React, { useState, useRef, useEffect } from 'react';

const InfoCarouselSection = ({ 
  title,
  highlightedText,
  description,
  cards = []
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const carouselRef = useRef(null);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      handleNext();
    }
    if (isRightSwipe) {
      handlePrev();
    }
  };

  const getCardStyle = (index) => {
    if (index === currentIndex) {
      // First card - full size
      return {
        transform: 'translateX(0) scale(1)',
        opacity: 1,
        zIndex: 20,
        width: '100%'
      };
    } else if (index === (currentIndex + 1) % cards.length) {
      // Second card - smaller and positioned to the right
      return {
        transform: 'translateX(70%) scale(0.75)',
        opacity: 0.8,
        zIndex: 10,
        width: '100%'
      };
    } else {
      // Hidden cards
      return {
        transform: 'translateX(150%) scale(0.7)',
        opacity: 0,
        zIndex: 0,
        width: '100%'
      };
    }
  };

  return (
    <div 
      className="w-full py-10 px-4 md:px-8 lg:px-16 primary-bg"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Section - Content */}
          <div className="text-white space-y-4 md:space-y-6">
            <h2 className="  font-bold leading-tight">
              <span className="text-white">{title} </span>
              {highlightedText && (
                <span className="secondary-text">{highlightedText}</span>
              )}
            </h2>
            <p className="text-gray-200   leading-relaxed">
              {description}
            </p>
          </div>

          {/* Right Section - Carousel Cards */}
          <div 
            className="relative flex items-center justify-center lg:justify-start min-h-[350px] md:min-h-[380px]"
            ref={carouselRef}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            {/* Cards Container */}
            <div className="relative w-full max-w-[240px] sm:max-w-[260px] md:max-w-[280px]" style={{ height: '320px' }}>
              {cards.map((card, index) => (
                <div
                  key={index}
                  className="absolute top-0 left-0 transition-all duration-500 ease-in-out"
                  style={getCardStyle(index)}
                >
                  <div className="bg-white rounded-2xl shadow-2xl overflow-hidden h-full">
                    {/* Card Image */}
                    <div className="relative h-36 sm:h-40 md:h-44 overflow-hidden">
                      <img
                        src={card.image}
                        alt={card.heading}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Card Content */}
                    <div className="p-4 sm:p-5 text-center justify-center">
                      <h3 className=" font-bold  mb-2">
                        {card.heading}
                      </h3>
                      <p className=" text-xs leading-relaxed">
                        {card.subheading}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Arrow - Positioned after the second card - Hidden on mobile */}
            <div 
              className="hidden lg:block absolute top-1/2 transform -translate-y-1/2 z-30"
              style={{ 
                left: 'calc(50% + 160px)',
              }}
            >
              <button
                onClick={handleNext}
                className="shadow-2xl transition-all duration-300 hover:scale-110 bg-transparent"
                aria-label="Next"
              >
                <img 
                  src='/assets/images/rightarrow.svg'
                  alt="Next" 
                  className="w-6 h-6 sm:w-7 sm:h-7 md:w-9 md:h-9"
                />
              </button>
            </div>

            {/* Dot Indicators for Mobile */}
            {/* <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex gap-2 lg:hidden">
              {cards.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? 'bg-white w-6'
                      : 'bg-white/50'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCarouselSection;